import { createAsyncThunk } from '@reduxjs/toolkit';
import { get, put, post, remove } from '../models/base';

export const fetchClientPortfolioPhotos = createAsyncThunk(
  'portfolio/fetchClientPortfolioPhotos',
  async (companyId, { rejectWithValue, getState }) => {
    const { pageNumber, perPage } = getState().portfolio;

    try {
      const response = await get(
        `/api/client_companies/${companyId}/client_portfolios?page=${pageNumber}&per_page=${perPage}`
      );
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const fetchPortfolioPhotos = createAsyncThunk(
  'portfolio/fetchPortfolioPhotos',
  async (companyId, { rejectWithValue, getState }) => {
    const { pageNumber, perPage } = getState().portfolio;

    try {
      const response = await get(
        `/companies/${companyId}/portfolios/photos?page=${pageNumber}&per_page=${perPage}`
      );
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const uploadPortfolioPhoto = createAsyncThunk(
  'portfolio/uploadPortfolioPhoto',
  async (uploadedFileData, { rejectWithValue, getState }) => {
    const { company } = getState().company;

    try {
      const queryPath = `/companies/${company.id}/portfolios`;
      const response = await post(queryPath, uploadedFileData);
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const deletePortfolioPhoto = createAsyncThunk(
  'portfolio/deletePortfolioPhoto',
  async (photoData, { rejectWithValue, getState }) => {
    const { company } = getState().company;

    try {
      const queryPath = ` /companies/${company.id}/portfolios/${photoData.portfolioId}/delete_photo?photo_id=${photoData.photoId}`;
      await remove(queryPath);
      return photoData.photoId;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const updatePortfolioPhotoSequence = createAsyncThunk(
  'portfolio/updatePortfolioPhotoSequence',
  async (photoIds, { rejectWithValue, getState }) => {
    let { company } = getState().company;
    const photoData = { ids: photoIds };

    try {
      const response = await put(
        `/companies/${company.id}/portfolios/bulk_sequence_updation`,
        photoData
      );
      return response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);
